// Form2.js
import React, { useState, useRef } from 'react';
import ChatBox from '../../custom_elements/ChatBox';
import { CustomInput, validationRules } from '../../custom_elements/CustomInput';
import CustomSelect from '../../custom_elements/CustomSelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSquareMinus } from '@fortawesome/free-solid-svg-icons';

export default function Form2({ nextForm, passGetFormData, passValidateAllFormFields, retrievedFormData = {}, sendChat}) {
    const formRefs = useRef([]);  // Reference array to store refs of CustomInput fields

    const [showPers, setShowPers] = useState(true);
    const [showFin, setShowFin] = useState(false);
    const [showPers2, setShowPers2] = useState(true);
    const [showFin2, setShowFin2] = useState(false);
    const [persNoArr, setPersNoArr] = useState([1]);
    const [updateDone, setUpdateDone] = useState(true);

    const getFormData = () => {
        console.log("INSIDE GETFORMDATA on Form2");
        if (updateDone) {
            console.log("persNoArr getFormData");
            console.log(persNoArr);
            const data = {'person':[]};
            persNoArr.forEach(persNo => {
                const form = document.getElementById('form2-'+persNo);
                const formData = new FormData(form);
                const formDataObj = {};
                for (let [key, value] of formData.entries()) {
                    formDataObj[key] = value;
                }
                data['person'].push(formDataObj);
                console.log("HEREEEE");
                console.log(persNoArr);
            });
            return data;
        } else {
            console.log("Bla Blub nicht fertig")
        }
    };

    React.useEffect(() => {
        console.log('Form2 mounted');
        console.log("INSIDE useEffect on Form2");

        passGetFormData(() => getFormData); // Pass the getFormData function to the parent
        if (retrievedFormData && 'person' in retrievedFormData) {
            if (retrievedFormData['person'].length > 1) {
                if (!(persNoArr.length === 2 && persNoArr.includes(1) && persNoArr.includes(2))) {
                    setPersNoArr([1, 2]);
                }
            }
        }
    }, [passGetFormData, persNoArr]);

    const validateAllFormFields = () => {
    console.log("validateAllFormFields in Form2");
    let isValid = true;

    let person1HasError = false;
    let person2HasError = false;
    let person1FinError = false;
    let person2FinError = false;

    let scrolled = false;

    Object.entries(formRefs.current).forEach(([key, inputRef]) => {
        if (inputRef && typeof inputRef.validateField === 'function') {
        const valid = inputRef.validateField();
        if (!valid) {
            isValid = false;

            const persNo = key.charAt(0); // "1" or "2"
            const fieldIndex = parseInt(key.slice(1)); // e.g. 17

            if (persNo === "1") {
            if (fieldIndex >= 17 && fieldIndex <= 22) {
                person1FinError = true;
            }
            else {
                person1HasError = true;
            }
            }
            if (persNo === "2") {
            if (fieldIndex >= 17 && fieldIndex <= 22) {
                person2FinError = true;
            }
            else {
                person2HasError = true;
            }
            }

            // Scroll to first error once
            if (!scrolled && inputRef?.scrollIntoView) {
            inputRef.scrollIntoView({ behavior: 'smooth', block: 'center' });
            scrolled = true;
            }
        }
        }
    });

    // Show correct sections
    if (person1HasError) {
        setShowPers(true);
    }
    else {
        setShowPers(false);
    }
    if (person2HasError) {
        setShowPers2(true);
    } else {
        setShowPers2(false);
    }
    if (person1FinError) {
        setShowFin(true);
    }
    else {
        setShowFin(false);
    }
    if (person2FinError) {
        setShowFin2(true);
    }
    else {
        setShowFin2(false);
    }

    return isValid;
    };

    React.useEffect(() => {
        //console.log("INSIDE useEffect passValidateAllFormFields on Form2");

        passValidateAllFormFields(() => validateAllFormFields);
    }, [passValidateAllFormFields]);


    const togglePersVisibility = () => {
        if (!showPers) {
            setShowFin(false);
            setShowFin2(false);
            setShowPers2(false);
        }
        setShowPers(prevState => !prevState);
    };
    const toggleFinVisibility = () => {
        if (!showFin) {
            setShowPers(false);
            setShowFin2(false);
            setShowPers2(false);
        }
        setShowFin(prevState => !prevState);
    };

    const togglePersVisibility2 = () => {
        if (!showPers2) {
            setShowFin2(false);
            setShowPers(false);
            setShowFin(false);
        }
        setShowPers2(prevState => !prevState);
    };
    const toggleFinVisibility2 = () => {
        if (!showFin2) {
            setShowPers2(false);
            setShowPers(false);
            setShowFin(false);
        }
        setShowFin2(prevState => !prevState);
    };

    const addPers = () => {
        setPersNoArr([...persNoArr, 2]);
        console.log("After setting state:", persNoArr);
    };

    const removePers = () => {
        if(window.confirm("Sind Sie sicher, dass Sie die zweite Person entfernen wollen?")){
            setPersNoArr([1]);
            console.log("After setting state:", persNoArr);
        }
    };

    return (
        <div className="formFieldBox">
            {persNoArr.map(persNo => (
            <form id={"form2-"+persNo}>
                <input type='hidden' name='pers_no' value={persNo} />
                <a onClick={persNo == 1 ? togglePersVisibility : togglePersVisibility2 } className="toggleButton" >
                    <span className="toggleSwitch">{!showPers && "+"}{showPers && "-"} </span>PERSON {persNo} - PERSÖNLICHE DATEN {persNo == 2 && <span onClick={removePers} className="remove-pers"><FontAwesomeIcon
                            size=""
                            icon={faSquareMinus}
                        /></span>}
                </a>
                {!showPers && <hr style={{width: "80%", margin: "auto"}} />}
                <div className={persNo == 1 ? (showPers ? "formFieldContent visible-content" : "hidden-content formFieldContent") : (showPers2 ? "formFieldContent visible-content" : "hidden-content formFieldContent")}>

                    <div className="fieldDiv">
                        <CustomSelect ref={el => formRefs.current[persNo+'1'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} name="famstand" label="Familienstand*" rules={[{ruleKey: "required"}]}>
                            <option value="1">Ledig</option>
                            <option value="2" >Verheiratet</option>
                            <option value="3" >Geschieden</option>
                            <option value="4" >Partnerschaft</option>
                            <option value="5" >Witwe/r</option>
                        </CustomSelect>

                        <CustomSelect ref={el => formRefs.current[persNo+'2'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} name="nation" label="Nationalität*" rules={[{ruleKey: "required"}]}>
                            <option value="1">Österreich</option>
                            <option value="2">Deutschland</option>
                            <option value="3">Andere</option>
                        </CustomSelect>
                    </div>

                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[persNo+'3'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} name="wohn_seit" type="date" sendChat={sendChat} label="Wohnhaft seit*" rules={[{ ruleKey: "date" },{ ruleKey: "required" }]} />
                        <CustomSelect ref={el => formRefs.current[persNo+'4'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} name="wohnsituation" label="Wohnsituation aktuell*" rules={[{ruleKey: "required"}]}>
                            <option value="5" >Eigentumswohnung</option>
                            <option value="1">Eigenheim</option>
                            <option value="2" >Miete</option>
                            <option value="3" >Untermieter/Mitbewohner</option>
                            <option value="6" >Genossenschaftswohnung</option>
                        </CustomSelect>
                    </div>

                    <div className="fieldDiv">
                        <CustomSelect ref={el => formRefs.current[persNo+'5'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} name="zukuenftiger_wohnstatus" label="Zukünftige Wohnsituation*" rules={[{ruleKey: "required"}]}>
                            <option value="5" >Eigentumswohnung</option>
                            <option value="1">Eigenheim</option>
                            <option value="2" >Miete</option>
                            <option value="3" >Untermieter/Mitbewohner</option>
                            <option value="6" >Genossenschaftswohnung</option>
                        </CustomSelect>
                        <CustomSelect ref={el => formRefs.current[persNo+'6'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} name="pkw" label="PKW Besitz*" rules={[{ruleKey: "required"}]}>
                            <option value="1">Ja</option>
                            <option value="2">Nein</option>
                        </CustomSelect>
                        {/* TODO PKW BESITZ? */}
                    </div>
                    <div className="fieldDiv">
                        <CustomSelect ref={el => formRefs.current[persNo+'7'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} name="branche" label="Branche*" rules={[{ruleKey: "required"}]}>
                            <option value="113">Banken</option>
                            <option value="114">Öffentlicher Dienst</option>
                            <option value="115">Energieversorgung</option>
                            <option value="116">Landwirtschaft</option>
                            <option value="117">Dienstleistung</option>
                            <option value="118">Produktion, Industrie</option>
                            <option value="119">Gesundheitswesen</option>
                            <option value="120">Personentransport, Postdienstleist</option>
                            <option value="121">Hotel, Gastronomie</option>
                            <option value="123">Reinigung</option>
                            <option value="124">Handel</option>
                            <option value="125">Baugewerbe</option>
                            <option value="126">Versicherung</option>
                            <option value="130">Gütertransport</option>
                            <option value="131">Verlagswesen, Kommunikation</option>
                            <option value="132">Stiftung</option>
                            <option value="133">Glücksspiel</option>
                            <option value="134">Waffen</option>
                            <option value="135">Bergbau</option>
                            <option value="136">Chemie</option>
                            <option value="122">Sonstiges</option>
                            {/*
                            INSERT INTO `n_branche` (`id`, `branche`, `id_schnittstelle`) VALUES
                                (113, 'Banken', 'BANKEN'),
                                (114, 'Öffentlicher Dienst', 'OEFFENTLICHER_DIENST'),
                                (115, 'Energieversorgung', 'ENERGIEVERSORGUNG'),
                                (116, 'Landwirtschaft', 'LANDWIRTSCHAFT'),
                                (117, 'Dienstleistung', 'DIENSTLEISTUNG'),
                                (118, 'Produktion, Industrie', 'PRODUKTION_INDUSTRIE'),
                                (119, 'Gesundheitswesen ', 'GESUNDHEITSWESEN'),
                                (120, 'Personentransport, Postdienstleist', 'PERSONENTRANSPORT_POSTDIENSTLEIST'),
                                (121, 'Hotel, Gastronomie', 'HOTEL_GASTRONOMIE'),
                                (122, 'Sonstiges', 'SONSTIGES'),
                                (123, 'Reinigung', 'REINIGUNG'),
                                (124, 'Handel', 'HANDEL'),
                                (125, 'Baugewerbe', 'BAUGEWERBE'),
                                (126, 'Versicherung', 'VERSICHERUNG'),
                                (130, 'Gütertransport', 'GUETERTRANSPORT'),
                                (131, 'Verlagswesen, Kommunikation', 'VERLAGSWESEN_KOMMUNIKATION'),
                                (132, 'Stiftung', 'STIFTUNG'),
                                (133, 'Glücksspiel', 'GLUECKSSPIEL'),
                                (134, 'Waffen', 'WAFFEN'),
                                (135, 'Bergbau', 'BERGBAU'),
                                (136, 'Chemie', 'CHEMIE');

                            */}
                        </CustomSelect>
                        <CustomSelect ref={el => formRefs.current[persNo+'8'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} name="beruf" label="Beruflicher Status*" rules={[{ruleKey: "required"}]}>
                            <option value="0" >Angestellte/r</option>
                            <option value="9" >Angestellte/r öffentl. Dienst</option>
                            <option value="1" >Arbeiter/in</option>
                            <option value="2" >Selbständig / Freiberuflich</option>
                            <option value="4" >Ausbildung</option>
                            <option value="5" >Haushalt / Arbeitslos / Karenz</option>
                            <option value="7" >Pension</option>
                        </CustomSelect>
                    </div>
                    <div className="fieldDiv">
                        <CustomSelect ref={el => formRefs.current[persNo+'9'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} name="ausbildung" label="Ausbildung*" rules={[{ruleKey: "required"}]}>
                            <option value="0">Studium</option>
                            <option value="1">Fachhochschule</option>
                            <option value="2">Matura</option>
                            <option value="3">Handelsschule</option>
                            <option value="4">Lehre</option>
                            <option value="5">Polytechnikum</option>
                            <option value="6">Hauptschule</option>
                        </CustomSelect>
                        <CustomSelect ref={el => formRefs.current[persNo+'10'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} name="p_beruf_befristet" label="Dienstverhältnis*" rules={[{ruleKey: "required"}]}>
                            <option value="1">Befristet</option>
                            <option value="2">Unbefristet</option>
                        </CustomSelect>
                    </div>
                    <div className="fieldDiv">
                        <CustomSelect  ref={el => formRefs.current[persNo+'11'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} name="beruf_in" label="Erwerbstätig in*" rules={[{ruleKey: "required"}]}>
                            <option value="0">Österreich</option>
                            <option value="1">Deutschland</option>
                        </CustomSelect>
                        <CustomInput ref={el => formRefs.current[persNo+'12'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} name="seit" type="date" sendChat={sendChat} label="Beschäftigt seit*" rules={[{ ruleKey: "date" }, { ruleKey: "required"}]} />
                    </div>
                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[persNo+'13'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} sendChat={sendChat} name="personen" label="Personen im gemeinsamen Haushalt (inkl. dir)*" rules={[{ ruleKey: "number" }, { ruleKey: "required" }]} />
                        <CustomInput ref={el => formRefs.current[persNo+'14'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} sendChat={sendChat} name="kinder" label="Kinder*" rules={[{ ruleKey: "number" }, { ruleKey: "required" }]} />
                    </div>
                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[persNo+'15'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} sendChat={sendChat} name="netto" label="Monatliches Nettoeinkommen*" rules={[{ ruleKey: "number" }, { ruleKey: "required" }]} />
                        <CustomInput ref={el => formRefs.current[persNo+'16'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} sendChat={sendChat} name="netto_sonst" label="Sonstige Einkommen*" rules={[{ ruleKey: "number" }, { ruleKey: "required" }]} />
                    </div>
                </div>
                <a onClick={persNo == 1 ? toggleFinVisibility : toggleFinVisibility2 } className="toggleButton" style={{marginBottom: "0px"}}>
                    <span className="toggleSwitch">{!showFin && "+"}{showFin && "-"} </span>PERSON {persNo} - MEINE AUSGABEN
                </a>
                <div className={persNo == 1 ? (showFin ? "formFieldContent visible-content" : "hidden-content formFieldContent") : (showFin2 ? "formFieldContent visible-content" : "hidden-content formFieldContent")}>

                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[persNo+'17'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} sendChat={sendChat} name="hh_leben" label="Lebenshaltungskosten*" rules={[{ ruleKey: "number" }, { ruleKey: "required" }]} />
                        <CustomInput ref={el => formRefs.current[persNo+'18'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} sendChat={sendChat} name="hh_telefon" label="TV/Telefon/Internet*" rules={[{ ruleKey: "number" }, { ruleKey: "required" }]} />
                    </div>
                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[persNo+'19'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} sendChat={sendChat} name="hh_kfz" label="KFZ/Mobilität*" rules={[{ ruleKey: "number" }, { ruleKey: "required" }]} />
                        <CustomInput ref={el => formRefs.current[persNo+'20'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} sendChat={sendChat} name="hh_wohn" label="Wohnkosten (inkl. Energie, BK,..)*" rules={[{ ruleKey: "number" }, { ruleKey: "required" }]} />
                    </div>
                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[persNo+'21'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} sendChat={sendChat} name="hh_sparensonst" label="Sonst. Verpflichtungen*" rules={[{ ruleKey: "number" }, { ruleKey: "required" }]} />
                        <CustomInput ref={el => formRefs.current[persNo+'22'] = el} formData={{  ...retrievedFormData['person'][persNo - 1],  info: retrievedFormData['info'] } || {info: retrievedFormData['info']}} sendChat={sendChat} name="hh_sparen" label="Sparen & Vorsorgen*" rules={[{ ruleKey: "number" }, { ruleKey: "required" }]} />
                    </div>
                    {/* TODO: VORBELASTUNGEN */}
                </div>
                {persNoArr.length == 1 && (
                <div className="add_form_button">
                    <span id="add_pers" onClick={addPers}>Zweite Person hinzufügen &nbsp;
                        <FontAwesomeIcon
                            size=""
                            icon={faPlus}
                        />
                    </span>
                </div>
                )}
            </form>
            ))}
        </div>
    );
}
